import { Skeleton } from '@worldcoo/ui/components/skeleton';

/**
 * Every donate step sets this as its `pendingComponent`: without it a suspending step falls through
 * to the router-wide default and the card the donate layout keeps mounted collapses to empty.
 */
export function DonateStepPending() {
	return (
		<div className="flex h-full grow flex-col gap-6">
			<div className="flex flex-col items-center gap-3">
				<Skeleton className="h-8 w-56" />
				<Skeleton className="h-4 w-full" />
				<Skeleton className="h-4 w-4/5" />
			</div>
			<div className="grid grid-cols-2 gap-2">
				<Skeleton className="h-14 rounded-[12px]" />
				<Skeleton className="h-14 rounded-[12px]" />
				<Skeleton className="h-14 rounded-[12px]" />
				<Skeleton className="h-14 rounded-[12px]" />
			</div>
			<Skeleton className="h-14 w-full rounded-[12px]" />
			<Skeleton className="h-14 w-full rounded-[12px]" />
		</div>
	);
}
